import styles from './styles.module.css'

import { RxMagicWand } from '@react-icons/all-files/rx/RxMagicWand'
import { RxPlus } from '@react-icons/all-files/rx/RxPlus'
import React from 'react'

import {
  Badge,
  Card,
  Flex,
  Heading,
  Link,
  Separator,
  Text,
} from 'components/ds'
import Button from 'components/ui/button'

type Props = {
  title: string
  description: React.ReactNode
  learnMoreUrl: string
  ctaHref?: string
  ctaLabel?: string
  ctaDisabledReason?: string
}

/**
 * Reusable card for add-ons promoted from the manage-subscription page.
 */
const SubscriptionAddOnCard = ({
  title,
  description,
  learnMoreUrl,
  ctaHref,
  ctaLabel = 'Add to plan',
  ctaDisabledReason,
}: Props): React.ReactElement => (
  <Card asChild className={styles.card} variant="surface">
    <article>
      <Flex direction="column" align="start" gap="2" width="100%">
        <Flex align="start" className={styles.titleRow}>
          <Heading as="h3" size="2" weight="medium">
            {title}
          </Heading>
          <Badge color="green" radius="small" size="1" variant="soft">
            <RxMagicWand aria-hidden="true" className={styles.badgeIcon} />
            Add on
          </Badge>
        </Flex>
        <Text as="p" color="gray" size="1">
          {description}
        </Text>
      </Flex>

      <Separator size="4" />

      <Flex
        align="start"
        className={styles.actions}
        justify="between"
        width="100%"
      >
        <Link asChild color="gray" size="2" underline="hover">
          <a
            className={styles.learnMore}
            href={learnMoreUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Learn more
          </a>
        </Link>

        <Button
          appearance="black"
          caption={ctaLabel}
          className={styles.cta}
          dataTestId="subscription-addon-cta"
          disabled={!ctaHref}
          iconNode={<RxPlus aria-hidden="true" className={styles.plusIcon} />}
          link={ctaHref}
          linkTarget="_blank"
          tooltip={ctaDisabledReason}
        />
      </Flex>
    </article>
  </Card>
)

export default SubscriptionAddOnCard
